import { useContext } from "react";

import { useTranslation } from "react-i18next";

import AuthContext from "context/auth/authContext";
import { usePermissions } from "shared";

const useFile = () => {
    const { user } = useContext(AuthContext);

    const { t } = useTranslation();

    const {
        isDownloadFileNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    const downloadBtnTooltipText =
        getNoPermissionTooltipTitle(PERMISSIONS.FileDownload) ||
        t("Table##download file");

    return { isDownloadFileNotAllowed, downloadBtnTooltipText, user };
};

export { useFile };
